import { render } from "./CertAlcoholActive.vue?vue&type=template&id=1157086c&scoped=true"
import script from "./CertAlcoholActive.vue?vue&type=script&lang=js"
export * from "./CertAlcoholActive.vue?vue&type=script&lang=js"

import "./CertAlcoholActive.vue?vue&type=style&index=0&id=1157086c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1157086c"]])

export default __exports__